import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MenuModule } from 'primeng/menu';
import { FormsModule } from '@angular/forms';
import { RippleModule } from 'primeng/ripple';
import { ButtonModule } from 'primeng/button';
import { SearchResult } from '../../../../graphql/generated/generated-types';

@Component({
  selector: 'app-shipping-selector',
  standalone: true,
  imports: [
    CommonModule,
    ButtonModule,
    RippleModule,
    FormsModule,
    MenuModule
  ],
  templateUrl: './shipping-selector.component.html',
  styleUrl: './shipping-selector.component.scss'
})
export class ShippingSelectorComponent {
  @Input() shippingMethods: SearchResult[] = [];
  @Input() smallLabel: boolean = false;
  @Input() darkMode: boolean = false;
  @Input() appendTo!: string;
  @Input() maxWidth!: number;
}
